import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-fp-widgets',
    imports: [TranslateModule],
    templateUrl: './fp-widgets.component.html',
    styleUrl: './fp-widgets.component.scss'
})
export class FpWidgetsComponent {}